import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { WorkflowSectionsActions } from '../actions/workflow-sections.actions';
import { WorkflowSectionDto } from '../dtos/workflow-section-dto.interface';
import { WorkflowSectionsService } from '../services/workflow-sections.service';

@Injectable()
export class WorkflowSectionsEffects {
    constructor(private actions$: Actions, private workflowSectionsService: WorkflowSectionsService) {}

    loadSections$ = createEffect(() =>
        this.actions$.pipe(
            ofType(WorkflowSectionsActions.loadSections),
            mergeMap(() => {
                return this.workflowSectionsService.getWorkflowSections().pipe(
                    map((response: WorkflowSectionDto[]) => WorkflowSectionsActions.sectionsLoaded({ response })),
                    catchError((error) => of(WorkflowSectionsActions.sectionsLoadFailure({ error }))),
                );
            }),
        ),
    );

    updateSection$ = createEffect(() =>
        this.actions$.pipe(
            ofType(WorkflowSectionsActions.updateSection),
            mergeMap((action) =>
                this.workflowSectionsService.updateWorkflowSection(action.sectionId, action.updateSectionDto).pipe(
                    map((response) => WorkflowSectionsActions.sectionUpdated({ response })),
                    catchError((error) => of(WorkflowSectionsActions.sectionUpdateFailure({ error }))),
                ),
            ),
        ),
    );
}
